import React, {FC} from 'react';

import {TransactionSchema, TransactionSummaryItem} from '~/entities/transactions-history';
import CopyButton from '~/shared/legacy_presentational-components/CopyButton/CopyButton';
import styles from './TransactionInfo.module.scss';

export interface TransactionInfoProps {
    details: TransactionSchema | null;
}

const TransactionInfo: FC<TransactionInfoProps> = ({details}) => {
    const printValue = (item: TransactionSummaryItem) => {
        const {value, long} = item;

        const cutValue = (value: string) => {
            const first20 = value.slice(0, 20);
            const last4 = value.slice(value.length - 4);
            return `${first20}...${last4}`;
        };

        return value ? (long ? cutValue(value) : value) : '—';
    };

    const valueClasses = (item: TransactionSummaryItem) => {
        const {name, state, value, long} = item;
        if (name === 'Status' && state) return `${styles.status} ${styles[state]}`;
        if (!value) return styles.emptyValue;
        if (long) return styles.longText;
        if (name === 'Beneficiary') return styles.beneficiary;
        if (name === 'Comment') return styles.comment;
        return styles.value;
    };

    const renderSummaryItem = (array: TransactionSummaryItem[]) =>
        array.map(item => (
            <div key={item.name} className={styles.row}>
                <div className={styles.title}>{item.name}</div>
                <div className={valueClasses(item)}>
                    <div>{printValue(item)}</div>
                    {item.copy && item.value && <CopyButton valueToCopy={item.value} />}
                </div>
            </div>
        ));

    return (
        <>
            {details && (
                <div className={styles.container}>
                    {details.summary.map((array, index) => (
                        <div key={index} className={styles.summaryItem}>
                            {renderSummaryItem(array)}
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default TransactionInfo;
